import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";
import { coreHasPermission } from "../../Configurations/corePermissionUtils";
import NotAllowed from "../../Exceptions/NotAllowed";

const Layout4 = ({
  loading,
  heading,
  Route,
  btnName,
  add_action,
  showAddButton = true,
  subtitle,
  headerExtra = null,
  onAddBtClick,
  addButtonDisabled = false,
  addButtonLoading = false,
}) => {
  const navigate = useNavigate();
  const { Permission } = usePermissionDataStore();
  const [showNotAllowed, setShowNotAllowed] = useState(false);

  const hasAddPermission = useMemo(() => {
    if (!add_action) {
      return true;
    }
    return coreHasPermission(Permission, add_action);
  }, [add_action, Permission]);

  if (showNotAllowed) {
    return <NotAllowed />;
  }

  return (
    <>
      <div className="ems-page-head">
        <div>
          <h1 className="ems-page-title">{heading}</h1>
          {subtitle && (
            <div className="ems-page-sub">
              <span>{subtitle}</span>
            </div>
          )}
        </div>
        {(headerExtra || (showAddButton && hasAddPermission && Route && btnName)) && (
          <div className="ems-head-actions">
            {headerExtra}
            {showAddButton && hasAddPermission && Route && btnName && (
            <button
              className="ems-btn ems-primary"
              disabled={addButtonDisabled || addButtonLoading || loading}
              onClick={() => {
                if (!coreHasPermission(Permission, add_action)) {
                  setShowNotAllowed(true);
                  return;
                }
                if (typeof onAddBtClick === "function") {
                  onAddBtClick();
                  return;
                }
                navigate(`${Route}/add`);
              }}
            >
              {addButtonLoading ? (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}
                >
                  <circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor"
                    strokeOpacity=".3" strokeWidth="2.5" fill="none" />
                  <path d="M7.5 2A5.5 5.5 0 0 1 13 7.5" stroke="currentColor"
                    strokeWidth="2.5" strokeLinecap="round" fill="none" />
                </svg>
              ) : (
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                  style={{ flexShrink: 0 }}>
                  <line x1="7.5" y1="1.5" x2="7.5" y2="13.5" />
                  <line x1="1.5" y1="7.5" x2="13.5" y2="7.5" />
                </svg>
              )}
              {btnName}
            </button>
            )}
          </div>
        )}
      </div>
      <div className="ems-section-divider" />
    </>
  );
};

export default Layout4;
